import { render, staticRenderFns } from "./elementHeadline.vue?vue&type=template&id=52ae3dce"
import script from "./elementHeadline.vue?vue&type=script&lang=ts"
export * from "./elementHeadline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports